import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import axios from '@/common/axios'


const LOGOUT_USER = 'LOGOUT_USER'

const jobtask_obj = {
    namespaced: true,
    state: {
        jobtask: []
    },
    mutations: {
        LOGOUT_USER (state) {
            state.jobtask = []
        }
    },
    getters: {
        jobtask (state) {
            return state.jobtask
        }
    },
    actions: {
        // API Calls
        async getAllJobtask ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('jobtask', {params: {order: data.order, type: data.type}})
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },

        async getActiveBankData ({ dispatch, commit, getters, rootGetters }, bank_id) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('jobtask/activebankdata', {params: {bank_id: bank_id}})
                return response.data
            } catch (error) {
                throw error
            }
        },

        async getTotalWithdraw ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('jobtask/totalwithdraw/' + data)
                return response.data
            } catch (error) {
                throw error
            }
        },

        async getJobtask ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                const response = await axios.get('jobtask/' + data)
                //console.log('getJobtask: ', response)
                return response.data
            } catch (error) {
                throw new Error(error)
            }
        },
        async createJobtask ({ dispatch, commit, getters, rootGetters }, data) {
            //console.log('createJobtask data: ', data)
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                return await axios.post('jobtask', data)
            } catch (error) {
                throw error
            }
        },
        async cancelJobtask ({ dispatch, commit, getters, rootGetters }, data) {
            try {
                //console.log('data', data)
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootGetters['user/accessToken']
                return await axios.put('jobtask/cancelreq/' + data.id, { customer_id: data.customer_id })
            } catch (error) {
                throw new Error(error)
            }
        },

        // Only Mutations
        async userLogout ({ dispatch, commit, getters, rootGetters }) {
            try {
                commit(LOGOUT_USER)
            } catch (error) {
                throw new Error(error)
            }
        },
    }
}

export default jobtask_obj
